export const CHAT_TILE_ID = 'ai-chat';
export const NOTIFICATION_CHAT_TILE_ID = 'notification-context';
export const CHAT_TILE_WIDTH = '432px';
// Widened dock used while a change-proposal section is in side-by-side compare.
export const CHAT_TILE_WIDTH_WIDE = '720px';
/** The threads rail sits inside the chat dock, so the dock grows by the rail plus one tile gap. */
export const CHAT_THREADS_RAIL_WIDTH = '320px';
export const CHAT_BAR_HEIGHT_PX = 55;
export const COLLAPSED_COMPOSER_BOTTOM_OFFSET_PX = 8;
export const COLLAPSED_COMPOSER_RESERVED_HEIGHT_PX = CHAT_BAR_HEIGHT_PX + COLLAPSED_COMPOSER_BOTTOM_OFFSET_PX;
/** Width left of the page content, such as the side navigation, set on the root so the composer centres on the content. */
export const COMPOSER_INSET_LEFT_VARIABLE = '--chat-composer-inset-left';

// Shared layoutId for framer-motion `LayoutGroup` pill morph between tiles.
export const COMPOSER_LAYOUT_ID = 'chat-composer';

export const COMPOSER_TRANSITION = { duration: 0.35, ease: 'easeInOut' as const };

// Grace period between an agent-action apply-turn finishing and the dock closing,
// so the user sees the applied result land before the chat leaves.
export const CHAT_AUTO_CLOSE_AFTER_COMPLETE_MS = 10_000;
